import VariantVoiceToken from '@apps/truevail/admin/tokens/variant_voice'
import MJSONDesigner from '@admin/components/mjson_designer'
import Dropdown from '@admin/components/form/dropdown'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class EmailVariantDesigner extends React.Component {

  static propTypes = {
    email_campaign: PropTypes.object
  }

  state = {
    variant_id: null
  }

  _handleVariant = this._handleVariant.bind(this)

  render() {
    const { variant_id } = this.state
    return (
      <div className="campaigns-variant-designer">
        <div className="campaigns-variant-designer-header">
          <Dropdown { ...this._getVariants() } />
        </div>
        <div className="campaigns-variant-designer-body">
          { variant_id &&
            <MJSONDesigner { ...this._getMJSONDesigner() } />          
          }
        </div>
      </div>
    )
  }

  _getMJSONDesigner() {
    const { email_campaign } = this.props
    const { variant_id } = this.state
    const variant = email_campaign.variants.find(variant => {
      return variant.id === variant_id
    })
    return {
      endpoint: `/truevail_email_campaign_variants/${variant_id}`,
      root_route: `/truevail/agency/email_campaigns/${email_campaign.id}/design`,
      language: variant.language,
      perspective: variant.perspective,
      type: 'email',
      versionable: true,
      key: variant_id
    }
  }

  _getVariants() {
    const { email_campaign } = this.props
    return {
      options: email_campaign.variants.map(variant => ({ 
        id: variant.id,
        perspective: variant.perspective,
        language: variant.language
      })),
      valueKey: 'id',
      textKey: 'name',
      format: VariantVoiceToken,
      deselectable: false,
      selectFirst: true,
      onChange: this._handleVariant
    }
  }

  _handleVariant(variant_id) {
    this.setState({ 
      variant_id
    })
  }
  
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <EmailVariantDesigner email_campaign={ props.email_campaign } />
})

export default Panel(null, mapPropsToPanel)
